import React from 'react';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableFooter from '@mui/material/TableFooter';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Paper from '@mui/material/Paper';
import SelectDeviceDropDown from './SelectDeviceDropDown';
import * as ETVConstants from '../ETVConstants';
import { Upload } from '@mui/icons-material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVPage from '../tools/ETVPage';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';

class FloorDirectory extends React.Component {

    constructor(props) {
      super(props);
      this.selectedScreens = this.selectedScreens.bind(this);
      this.closeScreenSelection = this.closeScreenSelection.bind(this);
      this.deviceSelected = this.deviceSelected.bind(this);
      this.devicesSelected = this.devicesSelected.bind(this);
    }

    state = {
      isLoaded:false,
      user_access:[],
      selected_screens: [],
      directoryElements:[],
      table_edited:false,
      window:'',
      info_title:'',
      info_message:'',
      info_type:'info',
      description_dialog_open:false,
      description_dialog_id:'',
      description_row_count:1,
      description_column_count:1,
      description_values:Array(18).fill('')
    }

    loadData( deviceID) {
      var url = ETVConstants.getServerBase()+"/directory?action=get_directory&device_id="+deviceID;
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            //console.log(JSON.stringify(result));
            var elems = this.createLocalElements(result.directory);
            this.setState({directoryElements:elems,table_edited:false});
          },
          (error) => {
            this.showInfoMessage(ETVConstants.trans("error"),error);
          }
        )
    }

    createLocalElements( serverElems) {
      var res = [];
      for(var i=0; i<serverElems.length; i++) {
        var serverE = serverElems[i];
        serverE.id = this.createID();
        serverE.position = i;
        serverE.has_error = false;
        res.push(serverE);
      }
      return res;
    }

    deviceSelected( deviceObj) {
      if(!deviceObj) return;
      var deviceID = deviceObj.id;
      //console.log("deviceID="+deviceObj.id+" selected");
      this.setState({selected_screens:[deviceID]});
      this.loadData(deviceObj.id);
    }

    devicesSelected( deviceIDs) {
      var firstID = deviceIDs[0];
      this.setState({selected_screens:deviceIDs});
      this.loadData(firstID);
    }

    selectedScreens(screenIDs) {
      //console.log("selected screens="+screenIDs);
      this.showWindow('select_screens_div',false);
      this.setState({selected_screens:screenIDs});
    }

    closeScreenSelection() {
      this.showWindow('select_screens_div',false);
    }

    showWindow(divID, show) {
      this.setState({show_overlay:show});
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(title, msg) {
      const infoType = title === ETVConstants.trans('success') ? 'success' : 'error';
      this.setState({window:'message_div',info_title:title,info_message:msg,info_type:infoType});
    }

    closeInfoMessage() {
      this.setState({window:'',show_overlay:false,info_title:'',info_message:'',info_type:'info'});
    }

    changeFloor(id,value) {
      this.setState((state) => {
        const changedElements = state.directoryElements.map(elem => (
          elem.id === id ? {...elem, floor:value} : elem
        ));
        const floorCounts = changedElements.reduce((counts, elem) => {
          if (elem.floor) counts[elem.floor] = (counts[elem.floor] || 0) + 1;
          return counts;
        }, {});

        return {
          directoryElements:changedElements.map(elem => {
            const duplicate = elem.floor && floorCounts[elem.floor] > 1;
            return {
              ...elem,
              has_error:duplicate,
              error_info:duplicate ? ETVConstants.trans("already_exists") : ''
            };
          }),
          table_edited:true
        };
      });
    }

    existsValueInFloors( value) {
      return this.state.floor_keys.includes(value);
    }

    openDescriptionDialog(elem) {
      const values = String(elem.info || '').split(';');
      const descriptionValues = Array(18).fill('');
      const valueCount = Math.max(1, Math.min(18, values.length));
      let rowCount = Number(elem.info_rows);
      let columnCount = Number(elem.info_columns);

      if (!Number.isInteger(rowCount) || rowCount < 1 || rowCount > 6 || ![1, 2, 3].includes(columnCount)) {
        if (valueCount <= 3) {
          rowCount = 1;
          columnCount = valueCount;
        } else if (valueCount === 4) {
          rowCount = 2;
          columnCount = 2;
        } else if (valueCount <= 6) {
          rowCount = 2;
          columnCount = 3;
        } else {
          rowCount = Math.ceil(valueCount / 3);
          columnCount = 3;
        }
      }

      values.slice(0, 18).forEach((value, index) => {
        descriptionValues[index] = value;
      });
      if (values.length > 18) {
        descriptionValues[17] = values.slice(17).join(' ');
      }

      this.setState({
        description_dialog_open:true,
        description_dialog_id:elem.id,
        description_row_count:rowCount,
        description_column_count:columnCount,
        description_values:descriptionValues
      });
    }

    closeDescriptionDialog() {
      this.setState({
        description_dialog_open:false,
        description_dialog_id:'',
        description_row_count:1,
        description_column_count:1,
        description_values:Array(18).fill('')
      });
    }

    changeDescriptionValue(index, value) {
      const sanitizedValue = value.replace(/;/g, '');
      this.setState((state) => {
        const values = [...state.description_values];
        values[index] = sanitizedValue;
        return {description_values:values};
      });
    }

    saveDescriptionDialog() {
      const id = this.state.description_dialog_id;
      const rowCount = this.state.description_row_count;
      const columnCount = this.state.description_column_count;
      const info = this.state.description_values
        .slice(0, rowCount * columnCount)
        .map(value => value.trim().replace(/;/g, ''))
        .join(';');

      this.setState((state) => ({
        directoryElements:state.directoryElements.map(elem => (
          elem.id === id
            ? {...elem, info:info, info_rows:rowCount, info_columns:columnCount}
            : elem
        )),
        table_edited:true,
        description_dialog_open:false,
        description_dialog_id:'',
        description_row_count:1,
        description_column_count:1,
        description_values:Array(18).fill('')
      }));
    }

    deleteElement(id) {
      var existingElems = this.state.directoryElements;
      var newElements = [];
      var counter = 0;
      for(var i=0; i<existingElems.length; i++) {
        var checkingElem = existingElems[i];
        if(checkingElem.id!==id) {
          checkingElem.position=counter;
          newElements.push(checkingElem);
          counter++;
        }
      }
      this.setState({directoryElements:newElements,table_edited:true});
    }

    submitElements() {
      var elems = this.state.directoryElements;
      var url = ETVConstants.getServerBase()+"/directory";
      var params = new URLSearchParams();
      params.append("action", "save");
      for(var i=0; i<elems.length; i++) {
        params.append("position."+(i+1)+".floor", elems[i].floor);
        params.append("position."+(i+1)+".desc", elems[i].info);
      }
      for(var k=0; k<this.state.selected_screens.length; k++) {
        params.append("device_id", this.state.selected_screens[k]);
      }
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      fetch(url,{
        method:'POST',
        headers: {
          'user_id':reqUserID,
          'access_token':accessToken,
          'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body:params.toString()
      })
        .then(async response => {
          const responseText = await response.text();
          let result;
          try {
            result = JSON.parse(responseText);
          } catch (_error) {
            throw new Error(`Upload failed (${response.status})`);
          }
          if (!response.ok) {
            throw new Error(result.reason || `Upload failed (${response.status})`);
          }
          return result;
        })
        .then(
          (result) => {
            if(result.result) {
              this.showInfoMessage(ETVConstants.trans("success"),"saved");
              this.setState({isLoaded:false,table_edited:false});
            }else{
              this.showInfoMessage(ETVConstants.trans("error"),result.reason || "failed");
            }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.showInfoMessage(ETVConstants.trans("error"),error.message || String(error));
          }
        )
    }

    guessNextFloorNr() {
      var len = this.state.directoryElements.length;
      if(len===0) return "1";
      var lastFloor = this.state.directoryElements[len-1].floor;
      try{
        var next = parseInt(lastFloor);
        if(!isNaN(next)) {
          return next+1;
        }
      }catch(error) {
        //console.log("could not parse "+lastFloor);
      };
      if(lastFloor.startsWith("B2")) return "B1";
      if(lastFloor.startsWith("B1")) return "L";
      if(lastFloor.startsWith("L")) return "1";
      return "0";
    }

    createID() {
      return Math.random()+"_"+Math.random();
    }

    addDirectoryRow() {
      var elem = {};
      elem.id = this.createID();
      elem.position = this.state.directoryElements.length;
      elem.floor = this.guessNextFloorNr();
      elem.info = "";
      elem.has_error=false;
      elem.error_info="";
      var newElems = this.state.directoryElements;
      newElems.push(elem);
      this.setState({directoryElements:newElems,table_edited:true});
    }

    canAddRow() {
      var elems = this.state.directoryElements;
      for(var i=0; i<elems.length; i++) {
        if(!elems[i].floor || elems[i].floor.length===0) {
          return false;
        }
      }
      return true;
    }

    hasInvalidRows() {
      return this.state.directoryElements.some(elem => !elem.floor || elem.has_error);
    }

    printDirectory(elems) {
      return(
        <div>
          <TableContainer component={Paper}>
            <Table>
                <TableHead>
                  <TableCell width='15%'>Floor Number</TableCell>
                  <TableCell width='80%'>Description</TableCell>
                  <TableCell width='5%'></TableCell>
                </TableHead>
                <TableBody>
                  {elems.map( item => {return this.printDirectoryElement(item)})}
                </TableBody>
                <TableFooter>
                </TableFooter>
            </Table>
          </TableContainer>
          <Button style={{marginTop:5}} disabled={!this.canAddRow()} color='primary' size='small' variant='contained' onClick={()=>this.addDirectoryRow()}>{ETVConstants.trans("add_entry")}</Button>
        </div>
      )
    }

    printDirectoryElement(elem) {
      return(
        <TableRow key={"dir_pos_"+elem.position}>
            <TableCell width="15%"><TextField fullWidth={true} error={elem.has_error} helperText={elem.error_info} value={elem.floor} onChange={e=>this.changeFloor(elem.id,e.target.value)}/></TableCell>
            <TableCell width="80%">
              <TextField
                fullWidth={true}
                value={elem.info}
                onClick={() => this.openDescriptionDialog(elem)}
                InputProps={{readOnly:true}}
                helperText="Click to set floor information"
                sx={{'& .MuiInputBase-root':{cursor:'pointer'}}}
              />
            </TableCell>
            <TableCell width="5%"><IconButton color='error' onClick={()=>{this.deleteElement(elem.id)}}><DeleteIcon/></IconButton></TableCell>
        </TableRow>
      )
    }

    render() {
      return (
        <ETVPage
          width="standard"
          icon={<ApartmentIcon fontSize="large" />}
          title={ETVConstants.trans('floor_directory')}
          description={ETVConstants.trans('floor_directory_explanation')}
          bottomActions={
            <ETVActionButton
              action="send"
              label={ETVConstants.trans('upload')}
              disabled={!this.state.table_edited || this.hasInvalidRows()}
              startIcon={<Upload />}
              onClick={() => this.submitElements()}
            />
          }
        >
          <div>
                <Paper variant="outlined" sx={{p:{xs:2,md:3},borderRadius:3}}>
                <SelectDeviceDropDown user_id={this.props.user_id} deviceSelected={this.deviceSelected} devicesSelected={this.devicesSelected} />
                <Divider sx={{my:2.5}} />
                {this.state.selected_screens.length>0?this.printDirectory(this.state.directoryElements):<span/>}
                <Button sx={{mt:2.5}} variant="outlined" onClick={() => this.showWindow('select_screens_div',true)}>{ETVConstants.trans("select_screens")} ({this.state.selected_screens.length})</Button>
                </Paper>
          </div>

          <div id='select_screens_div' style={{display:this.state.window==='select_screens_div'?'block':'none'}}>
                <SelectAvailableScreensNew isOpen={this.state.window==='select_screens_div'} user_id={this.props.user_id} closeHook={this.closeScreenSelection} selectedScreens={this.selectedScreens} selected={this.state.selected_screens?this.state.selected_screens:[]}/>
          </div>

          <ETVMessagePopup
            open={this.state.window==='message_div'}
            onClose={()=>this.closeInfoMessage()}
            type={this.state.info_type}
            title={this.state.info_title}
            message={this.state.info_message}
            closeLabel={ETVConstants.trans('close')}
          />

          <Dialog
            open={this.state.description_dialog_open}
            onClose={() => this.closeDescriptionDialog()}
            maxWidth="sm"
            fullWidth>
            <DialogTitle>Edit floor description</DialogTitle>
            <DialogContent dividers>
              <Box sx={{display:'flex', gap:2}}>
                <FormControl fullWidth>
                  <InputLabel id="floor-info-rows-label">Rows</InputLabel>
                  <Select
                    labelId="floor-info-rows-label"
                    value={this.state.description_row_count}
                    label="Rows"
                    onChange={(e) => this.setState({description_row_count:Number(e.target.value)})}>
                    {[1, 2, 3, 4, 5, 6].map(value => (
                      <MenuItem key={`row-count-${value}`} value={value}>{value}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="floor-info-columns-label">Columns</InputLabel>
                  <Select
                    labelId="floor-info-columns-label"
                    value={this.state.description_column_count}
                    label="Columns"
                    onChange={(e) => this.setState({description_column_count:Number(e.target.value)})}>
                    {[1, 2, 3].map(value => (
                      <MenuItem key={`column-count-${value}`} value={value}>{value}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box
                sx={{
                  display:'grid',
                  gridTemplateColumns:`repeat(${this.state.description_column_count}, minmax(0, 1fr))`,
                  gap:2,
                  mt:2
                }}>
                {this.state.description_values
                  .slice(0, this.state.description_row_count * this.state.description_column_count)
                  .map((value, index) => (
                    <TextField
                      key={`description-cell-${index}`}
                      autoFocus={index === 0}
                      fullWidth
                      label={`Row ${Math.floor(index / this.state.description_column_count) + 1}, column ${(index % this.state.description_column_count) + 1}`}
                      value={value}
                      onKeyDown={(e) => {
                        if (e.key === ';') e.preventDefault();
                      }}
                      onChange={(e) => this.changeDescriptionValue(index, e.target.value)}
                    />
                  ))}
              </Box>

              <Typography variant="caption" color="text.secondary" sx={{display:'block', mt:1.5}}>
                Semicolons are reserved as row separators and cannot be entered in the text.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.closeDescriptionDialog()}>
                {ETVConstants.trans('cancel') || 'Cancel'}
              </Button>
              <Button variant="contained" onClick={() => this.saveDescriptionDialog()}>
                Set floor info
              </Button>
            </DialogActions>
          </Dialog>
        </ETVPage>
      )
    }
}

export default FloorDirectory;
